import { Breadcrumb, Button, Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { spacing } from '../../theming';
import UpdatedAgo from './UpdatedAgo';

/**
 * Breadcrumb, title and subtitle; with `showControls`, also "Updated N min ago" and Refresh. The range picker sits
 * with the period it filters, in the stats section (SC-QA-102).
 */
export default function VinExtractionHeader({ showControls, lastFetchedAt, refreshing, onRefresh }) {
    const { t } = useTranslation('vinExtraction');

    return (
        <Flex vertical gap={spacing[2]}>
            <Breadcrumb items={[{ title: t('breadcrumb.admin') }, { title: t('breadcrumb.page') }]} />
            <Flex justify="space-between" align="flex-start" gap={spacing[2]} wrap="wrap">
                <Flex vertical gap={spacing[0.5]}>
                    <Typography.Title level={3} style={{ margin: 0 }}>
                        {t('title')}
                    </Typography.Title>
                    <Typography.Text type="secondary">{t('subtitle')}</Typography.Text>
                </Flex>
                {showControls && (
                    <Flex align="center" gap={spacing[2]}>
                        <UpdatedAgo lastFetchedAt={lastFetchedAt} />
                        <Button
                            onClick={onRefresh}
                            loading={refreshing}
                            icon={<i className="fi fi-rr-refresh" aria-hidden="true" />}
                        >
                            {t('refresh')}
                        </Button>
                    </Flex>
                )}
            </Flex>
        </Flex>
    );
}
